import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function MachineCategory() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [formData, setFormData] = useState({
        name: "", description: "", status: 1, addedby: userName, ip_add: ipAddress,
    });
    useEffect(() => {
        getMachineCategory();
    }, []);
    const getMachineCategory = () => {
        setLoading(true);
        axios
            .get(baseUrl + "machine-category/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Machine Categories.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value,
        });
    };
    const clearForm = () => {
        setFormData({
            name: "", description: "", status: 1, addedby: userName, ip_add: ipAddress,
        });
    };
    const saveMachineCategory = () => {
        const data = new FormData();
        data.append("name", formData.name);
        data.append("description", formData.description);
        data.append("status", formData.status);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "machine-category/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Success", text: "Machine Category saved successfully.",
                });
                clearForm();
                getMachineCategory();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Machine Category.",
                });
            });
    };
    const deleteMachineCategory = (id) => {
        Swal.fire({
            title: "Delete Machine Category?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(`machine-category/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Machine Category deleted successfully.",
                        });
                        getMachineCategory();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Machine Category.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "name", headerName: "Category Name", flex: 1,
    }, {
        field: "description", headerName: "Description", flex: 2,
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value === 1 ? "Active" : "Inactive",
    },];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Machine Category
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">

                            <label>Category Name</label>

                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </select>

                        </div>

                        <div className="col-md-12 mb-3">

                            <label>Description</label>

                            <textarea
                                className="form-control"
                                rows="3"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveMachineCategory}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Machine Category List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}
                                    
                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
export default MachineCategory;